<script>
  import { flatenObject } from "../../../../../../Script/flatenObject"
  import notify from "../../../../../../Script/notify"
  import AttributeContent from "./Components/attributeContent.svelte"
  import { checkMaxCharacters } from "../../Script/tempNamevalidation"
  import { createEventDispatcher, onMount } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Object} Represents the parsed JSON data.
   */
  export let parsedJson

  export let changeAttribute = false

  let form
  /**
   *  @type {string} Represents the attribute value.
   */
  let attributeValue = ""
  /**
   * @type {string} Represents  the value of the input attribute.
   */
  let inputAttributeValue
  /**
   * @type {Boolean} Set attribute button initially disabled state
   */
  let disableAttributeButton = true
  /**
   * @type {String} defines the type the active layer
   */
  export let layerType = "text"
  /**
   * @type {Boolean} whether to show attribute section or not
   */
  let showAttributeSection = false
  let focusInput
  onMount(() => {
    if (!changeAttribute) {
      focusInput.focus()
    }
  })

  const handleSubmit = async () => {
    try {
      if (changeAttribute) {
        getAttrFromDropdown()
        return
      }
      if (layerType == "image") {
        // layer type image
        if (!inputAttributeValue.trim()) throw "Layer name can't be Empty"

        let dispatchData = {
          attribute: inputAttributeValue,
          type: layerType,
          value: "",
        }
        dispatch("setLayer", dispatchData)
      } else {
        // layer type text
        if (showAttributeSection) {
          // dropdown
          getAttrFromDropdown()
        } else {
          // input area
          if (!inputAttributeValue.trim()) throw "Layer name can't be Empty"
          let dispatchData = {
            attribute: inputAttributeValue,
            type: layerType,
            value: "",
          }
          dispatch("setLayer", dispatchData)
        }
      }
    } catch (error) {
      const info = "PAGE: File template editor\nEVENT: While setting attribute"
      notify.danger(error, info)
    }
  }

  const getAttrFromDropdown = () => {
    // Process the form data and update the attribute and value based on the selected options
    const data = new FormData(form)
    let formData = [...data]

    // Iterate over the formData array and concatenate the attributeValue with the selected options
    for (let i = 0; i < formData.length; i++) {
      let tempValue = formData[i][1]
      if (tempValue != "None") {
        attributeValue = attributeValue ? `${attributeValue}_${tempValue}` : formData[i][1]
      }
    }

    // Flatten the parsedJson object to create underscored metadata keys
    let flatObject = flatenObject(parsedJson)

    let dispatchData = {
      attribute: attributeValue,
      type: layerType,
      value: flatObject[attributeValue] ? flatObject[attributeValue] : "text",
    }
    dispatch("setLayer", dispatchData)
  }

  $: checkEmptyInput(inputAttributeValue)

  const checkEmptyInput = (value) => {
    disableAttributeButton = !value
  }
</script>

<svelte:window
  on:keypress={(e) => {
    if (e.key == "Enter") {
      e.preventDefault()
      handleSubmit()
    }
  }}
/>

<div class="fixed inset-0 z-10 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <form bind:this={form} on:submit|preventDefault>
    <div class="w-[400px]">
      <div class="w-full rounded-t-md bg-darkgray p-5">
        <div class="flex justify-between pb-3 text-xl font-bold tracking-wide text-slate-100">
          <!-- {#if changeAttribute} -->
          <h1>Set Attribute</h1>
          <!-- {:else}
            <h1>Set Attribute</h1>
            {#if layerType == "text"}
              <button
                on:click={() => {
                  inputAttributeValue = ""
                  showAttributeSection = !showAttributeSection
                }}
              >
                <div data-tooltip="Use Attribute" tooltip-position="left" class="text-white">
                  <i class="fa-solid fa-brackets-curly" />
                </div>
              </button>
            {/if}
          {/if} -->
        </div>

        {#if showAttributeSection || changeAttribute}
          <p class="pb-3 text-sm font-normal leading-relaxed text-gray-300">Here you can choose the attributes based on the document template you already choosen.</p>
          <button class="flex w-full rounded-md">
            <AttributeContent bind:disableAttributeButton {parsedJson} />
          </button>
        {:else}
          <div class="group relative w-full rounded-md">
            <div class="flex justify-between">
              <div class="absolute left-3 top-2 select-none text-sm font-bold text-gray-g00 {inputAttributeValue ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
            </div>
            <input
              bind:this={focusInput}
              bind:value={inputAttributeValue}
              on:keypress={() => {
                inputAttributeValue = checkMaxCharacters(inputAttributeValue)
              }}
              on:paste={() => {
                inputAttributeValue = checkMaxCharacters(inputAttributeValue)
              }}
              type="text"
              required
              class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none invalid:animate-shake focus:ring-2 focus:ring-extraBlue-500 focus:invalid:ring-red-500"
            />
          </div>
        {/if}
      </div>
    </div>
    <div class="flex w-[400px] justify-between rounded-b-md bg-[#242424] px-5 py-3">
      <button on:click class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none">
        <span class="text-white">
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none group-hover:text-white">&nbsp;&nbsp;Close</span>
      </button>

      <button disabled={disableAttributeButton} type="submit" on:click={handleSubmit} class="active:bg-green-g00 group flex h-9 w-2/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
        <span class="text-white">
          <i class="fa-solid fa-memo-pad" />
        </span>
        <span class="select-none group-hover:text-white">&nbsp;&nbsp;Set Attribute</span>
      </button>
    </div>
  </form>
</div>
